import { createFileRoute } from "@tanstack/react-router";
import Page from "@project/admin/pages/residents/resident-family";

export const Route = createFileRoute("/admin/_residents/resident-family")({
  component: Page,
});
